module.exports = __webpack_public_path__ + "img/app-logo.d0bc9e8c.png";